// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".card-info-text[data-v-3a99ae60]{text-align:center}.card-info-text[data-v-3a99ae60] ol,.card-info-text[data-v-3a99ae60] ul{text-align:left!important;margin-left:0}@media screen and (min-width:600px){.card-info-text[data-v-3a99ae60] ol,.card-info-text[data-v-3a99ae60] ul{margin-left:1.5rem}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
